import { LocaleEnum } from '@systemeio/ui'

export const getStripeHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/1281-hoe-verbind-je-je-stripe-account-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/1109-so-verbinden-sie-ihr-stripe-konto-mit-systeme-io'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/224-comment-connecter-votre-compte-stripe-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2213-how-to-connect-your-stripe-account-to-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/591-como-conectar-sua-conta-stripe-a-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/556-como-conectar-tu-cuenta-de-stripe-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/501-come-collegare-il-tuo-conto-stripe-a-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/225-how-to-connect-your-stripe-account-to-systeme-io'
    }
  }
}
